import { isFunction } from "lodash-es";

const DEFAULT_CHECK_INTERVAL_MS = 25;
const DEFAULT_TIMEOUT_MS = 10_000; // 10s

interface Options {
  checkInterval?: number; // check element presence every checkInterval ms
  failureCallback?: () => void;
  timeout?: number; // fail after totalTimeout ms spent on waiting, not defined or 0 to unlimited
}

const waitForElement = (
  selector: (() => boolean) | string,
  callback: () => void,
  options?: Partial<Options>
): number | undefined => {
  const checkInterval = options?.checkInterval ?? DEFAULT_CHECK_INTERVAL_MS;
  const timeout = options?.timeout ?? DEFAULT_TIMEOUT_MS;
  let timeSpent = 0;

  const isElementPresent = isFunction(selector)
    ? (selector as () => boolean)
    : () => !!document.querySelector(selector);

  if (isElementPresent()) {
    callback();
    return;
  }

  const refreshInterval = window.setInterval(() => {
    if (isElementPresent()) {
      window.clearInterval(refreshInterval);
      callback();
    } else {
      timeSpent += checkInterval;
      if (timeout && timeSpent > timeout) {
        window.clearInterval(refreshInterval);
        options?.failureCallback?.();
      }
    }
  }, checkInterval);

  return refreshInterval;
};

export default waitForElement;
